var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrap"},[_c('van-loading',{attrs:{"type":"spinner","vertical":"","size":"48px"}},[_vm._v(" 数据加载中... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }